import { USE_REST_API } from '../config'

async function apiFetch(
	url: string,
	method = 'GET',
	data: Record<string, unknown> | null = null
): Promise<Record<string, unknown>> {
	let body: string | null = null
	let contentType = ''

	if (USE_REST_API) {
		body = data ? JSON.stringify(data) : null
		contentType = 'application/json'
	} else {
		contentType = 'application/x-www-form-urlencoded'
		const formBody = [] as string[]
		if (data) {
			// eslint-disable-next-line no-restricted-syntax, guard-for-in
			for (const property in data) {
				const encodedKey = encodeURIComponent(property)
				const encodedValue = encodeURIComponent(JSON.stringify(data[property]))
				formBody.push(`${encodedKey}=${encodedValue}`)
			}
			body = formBody.join('&')
		}
	}

	const response = await fetch(url, {
		headers: { 'Content-Type': contentType },
		credentials: 'include',
		method,
		body,
	})
	return response.json()
}

export default apiFetch
